import React, { Component } from 'react';
import { DataTypeVente } from '../../data/DataTypeVente.jsx';
import { EUIComboBox } from '../EUI/EUIComboBox';

export class ComboBoxTypeVente extends Component {

    static defaultProps = {
        idProduit: undefined,
        idSousProduit: undefined,
        label: "Type de vente",
        placeholder: "Type de vente",
    };

    render = () => {

        const { idProduit, idSousProduit } = this.props;

        let fetchMethod = null;
        if (!!idProduit && !!idSousProduit)
            fetchMethod = () => DataTypeVente._chargementTypeVente(idProduit, idSousProduit);

        return <EUIComboBox
            {...this.props}
            fetchMethod={fetchMethod}
            itemKey={item => item.idTypeVente}
            itemText={item => item.typeVente}
            stamp={[idProduit, idSousProduit]}
        />;

    };

};